<!-- 商品列表 -->
<template>
  <div>
    <div class="product-list pointer" :style="{'margin-right':(itemIndex+1)%splitNumber==0?'0px':'10px'}">
    <div class="main-img">
      <img class="product-img" :src="itemData.imgUrl" />
      <img class="product-tag-img" src="./img/product-good-icon@2x.png" alt=""/>
    </div>
    <div class="product">
        <div class="p-certified">已认证</div>
      <p class="p-price"><i>￥</i><span>{{itemData.price}}</span></p>
      <p class="p-name in2clamp">{{itemData.name}}</p>
    </div>
    <div class="product-handle">
      <!-- <div class="handle-btn collect-btn pointer">
        <img :src="imgUrl2" alt="" /><span>收藏</span>
      </div> -->
      <div class="handle-btn add-cart-btn pointer"   @mouseover="isShowCartIcon=true" @mouseleave="isShowCartIcon=false">
        <img v-show="!isShowCartIcon" src="./img/icon-cart1@2x.png" alt="" />
        <img  v-show="isShowCartIcon" src="./img/icon-cart-default@2x.png" alt="" />
        <span>加入购物车</span>
      </div>
    </div>
  </div>
  </div>
</template>

<script>

export default {
   props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    itemIndex:{
      type:Number,
      default:()=>{
        return 0;
      }
    },
    splitNumber:{
      type:Number,
      default:()=>{
        return 5;
      }
    },
    
    },
  data() {
    return {
      isShowCartIcon:false,
        imgUrl2: require('./img/collect-icon@2x.png'),
        isCollect:true
    };
  },

  components: {},

  computed: {},

  created() {},
  methods: {
     
  },
};
</script>
<style lang='scss' scoped>
@import '../../../../assets/css/theme.scss';
@import "@/assets/css/mixin/flex.scss";
.product-list {
  width: 232px;
  background: #ffffff;
  border: 1px solid #e7e7e7;
  position: relative;
  font-size: 0;
  margin-right: 10px;
  height:398px;
 
  &:hover{
    box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.23);
    border: 1px solid $main-col;
  }
  .main-img {
    text-align: center;
    padding: 10px 0 0 0;
    .product-img {
      width: 212px;
      height: 212px;
    }
    .product-tag-img {
      left: 16px;
      position: absolute;
      width: 40px;
      height: 50px;
      top: 0;
    }
  }
  .product {
    margin: 10px 10px 0 10px;
    font-size: 0;
    img {
      width: 45px;
      height: 16px;
    }
    .p-certified{
        width: 48px;
        height:20px;
        line-height: 20px;
        background: url('./img/certified-icon.png');
        background-size: 100% 100%;
        font-size: 12px;
        color:#fff;
        text-align: center;
    }
    .p-price {
      margin-top: 10px;
      line-height: 22px;
      height:22px;
      i {
        font-size: 18px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #EF4C56;
      }
      span {
        font-size: 22px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #EF4C56;
      }
    }
    .p-name {
      font-size: 12px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      // line-height: 20px;
      height: 30px;
      margin-top:10px;
    }
    .p-s-name{
      font-size: 12px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
      line-height: 1;
      color: #999999;
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }
  .product-handle {
    display: flex;
    // border: 1px solid #d9d9d9;
    margin: 20px 10px 0 10px;
    justify-content: space-between;
    .handle-btn {
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #999999;
      height: 34px;
      border-top: 1px solid #d9d9d9;
      border-left: 1px solid #d9d9d9;
      border-bottom: 1px solid #d9d9d9;

      @include flex(center, center, row);
    }
    .collect-btn {
      width: 74px;
      &:hover{
          color: #FC4948;
      }
      img{
          width: 14px;
          height: 14px;
          margin-right: 7px;
      }
    }
    .add-cart-btn {
      // width: 136px;
      width: 100%;
      border:1px solid $main-col;
      color: $main-col;
      &:hover{
          background-color: $main-col;
          color: #ffffff;
          //  background-image: url('../../../assets/images/product/icon-cart-default@2x.png') no-repeat center;
      }
      img{
          width: 15px;
          height: 15px;
          margin-right: 7px;
      }
    }
  }
}
</style>
